var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "home-container" }, [
    _c(
      "div",
      { staticClass: "hx-breadcrumb" },
      [
        _c(
          "el-breadcrumb",
          { attrs: { "separator-class": "el-icon-arrow-right" } },
          [
            _c("el-breadcrumb-item", [_vm._v("招接待宾馆预约系统")]),
            _c("el-breadcrumb-item", [_vm._v("宾馆基本信息")]),
            _c("el-breadcrumb-item", [_vm._v("信息编辑")]),
          ],
          1
        ),
      ],
      1
    ),
    _c("div", { staticClass: "hx-form-container box-shadow" }, [
      _c(
        "div",
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.formLoading,
                  expression: "formLoading",
                },
              ],
              ref: "commodityForm",
              attrs: { model: _vm.listParams, "label-width": "150px" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "所属片区：", prop: "region" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "300px" },
                      attrs: { size: "small", placeholder: "请选择所属片区" },
                      model: {
                        value: _vm.listParams.region,
                        callback: function ($$v) {
                          _vm.$set(_vm.listParams, "region", $$v)
                        },
                        expression: "listParams.region",
                      },
                    },
                    [
                      _c("el-option", { attrs: { label: "对内", value: "1" } }),
                      _c("el-option", { attrs: { label: "对外", value: "2" } }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "宾馆名称：" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "300px" },
                    attrs: { size: "small", disabled: "" },
                    model: {
                      value: _vm.listParams.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.listParams, "name", $$v)
                      },
                      expression: "listParams.name",
                    },
                  }),
                ],
                1
              ),
              _c("el-form-item", { attrs: { label: "宾馆图片：" } }, [
                _c(
                  "div",
                  {
                    staticClass: "upload-thumbnail-img",
                    attrs: { loading: _vm.uploading },
                  },
                  [
                    _c("i", {
                      staticClass: "el-icon-circle-plus-outline upload-icon",
                    }),
                    _c("input", {
                      staticClass: "hidden-upload",
                      attrs: {
                        type: "file",
                        accept: ".png,.jpg,.jpeg,.gif",
                        id: "uploadDom",
                      },
                      on: { change: _vm.doUpload },
                    }),
                  ]
                ),
                _vm.listParams.pictures.length > 0
                  ? _c(
                      "div",
                      { staticClass: "wrap-thumbnail-img" },
                      _vm._l(_vm.listParams.pictures, function (item, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "thumbnail-img" },
                          [
                            _c("div", { staticClass: "combined-img" }, [
                              _c("img", {
                                key: index,
                                staticClass: "thumbnail-img-wrapped",
                                attrs: { src: item, alt: "" },
                              }),
                              _c("div", { staticClass: "hover-img" }, [
                                _c("i", {
                                  staticClass:
                                    "el-icon-circle-close-outline close-btn",
                                  on: {
                                    click: function ($event) {
                                      return _vm.deleteImg(index)
                                    },
                                  },
                                }),
                              ]),
                            ]),
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "宾馆地址：", prop: "address" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "300px" },
                    attrs: {
                      type: "textarea",
                      row: 6,
                      placeholder: "请输入宾馆地址",
                    },
                    model: {
                      value: _vm.listParams.address,
                      callback: function ($$v) {
                        _vm.$set(_vm.listParams, "address", $$v)
                      },
                      expression: "listParams.address",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "宾馆标注：" } },
                [
                  _vm.listParams.longitude && _vm.listParams.latitude
                    ? _c("el-amap", {
                        attrs: {
                          vid: "container",
                          zoom: 16,
                          center: [
                            _vm.listParams.longitude,
                            _vm.listParams.latitude,
                          ],
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "周边介绍：", prop: "surroundDesc" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "300px" },
                    attrs: {
                      type: "textarea",
                      row: 4,
                      placeholder: "请输入周边介绍",
                    },
                    model: {
                      value: _vm.listParams.surroundDesc,
                      callback: function ($$v) {
                        _vm.$set(_vm.listParams, "surroundDesc", $$v)
                      },
                      expression: "listParams.surroundDesc",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "订房热线：", prop: "tel" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "300px" },
                    attrs: { size: "small", placeholder: "请输入订房热线" },
                    model: {
                      value: _vm.listParams.tel,
                      callback: function ($$v) {
                        _vm.$set(_vm.listParams, "tel", $$v)
                      },
                      expression: "listParams.tel",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "联系方式：" } },
                [
                  _vm.listParams.concats.length > 0
                    ? _vm._l(_vm.listParams.concats, function (item, index) {
                        return _c(
                          "div",
                          { key: index, staticStyle: { display: "flex" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "200px" },
                              attrs: {
                                size: "small",
                                placeholder: "请输入联系人：",
                              },
                              model: {
                                value: item.name,
                                callback: function ($$v) {
                                  _vm.$set(item, "name", $$v)
                                },
                                expression: "item.name",
                              },
                            }),
                            _c("el-input", {
                              staticStyle: {
                                width: "300px",
                                "margin-left": "20px",
                                "margin-right": "20px",
                              },
                              attrs: {
                                size: "small",
                                placeholder: "请输入联系电话：",
                              },
                              model: {
                                value: item.mobile,
                                callback: function ($$v) {
                                  _vm.$set(item, "mobile", $$v)
                                },
                                expression: "item.mobile",
                              },
                            }),
                            _vm.listParams.concats.length > 1
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.deleteItem(index)
                                      },
                                    },
                                  },
                                  [_vm._v(" 删除 ")]
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      })
                    : _vm._e(),
                  _c(
                    "el-button",
                    {
                      staticStyle: { width: "60px" },
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.addItem },
                    },
                    [_vm._v(" 新 增 ")]
                  ),
                ],
                2
              ),
              _c(
                "el-form-item",
                { attrs: { label: "退房时间：", prop: "checkTime" } },
                [
                  _c("el-time-select", {
                    staticStyle: { width: "300px" },
                    attrs: {
                      size: "small",
                      "picker-options": {
                        start: "08:30",
                        step: "00:15",
                        end: "14:00",
                      },
                      placeholder: "选择时间",
                    },
                    model: {
                      value: _vm.listParams.checkTime,
                      callback: function ($$v) {
                        _vm.$set(_vm.listParams, "checkTime", $$v)
                      },
                      expression: "listParams.checkTime",
                    },
                  }),
                ],
                1
              ),
              _c("el-form-item", { attrs: { label: "早餐：" } }, [
                _c(
                  "div",
                  { staticStyle: { display: "flex" } },
                  [
                    _c(
                      "el-radio",
                      {
                        staticStyle: { "line-height": "32px" },
                        attrs: { label: true },
                        model: {
                          value: _vm.listParams.breakfast,
                          callback: function ($$v) {
                            _vm.$set(_vm.listParams, "breakfast", $$v)
                          },
                          expression: "listParams.breakfast",
                        },
                      },
                      [_vm._v(" 有 ")]
                    ),
                    _c(
                      "el-radio",
                      {
                        staticStyle: { "line-height": "32px" },
                        attrs: { label: false },
                        model: {
                          value: _vm.listParams.breakfast,
                          callback: function ($$v) {
                            _vm.$set(_vm.listParams, "breakfast", $$v)
                          },
                          expression: "listParams.breakfast",
                        },
                      },
                      [_vm._v(" 无 ")]
                    ),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "line-height": "32px",
                          "padding-left": "20px",
                        },
                      },
                      [_vm._v("早餐价格:")]
                    ),
                    _c("el-input-number", {
                      staticClass: "mgl20",
                      attrs: {
                        disabled: !_vm.listParams.breakfast,
                        size: "small",
                        min: 0,
                      },
                      model: {
                        value: _vm.listParams.breakfastPrice,
                        callback: function ($$v) {
                          _vm.$set(_vm.listParams, "breakfastPrice", $$v)
                        },
                        expression: "listParams.breakfastPrice",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "配套设施：" } },
                [
                  _c(
                    "el-checkbox",
                    {
                      attrs: { indeterminate: _vm.isIndeterminate1 },
                      on: { change: _vm.handleCheckAllFacilitiesChange },
                      model: {
                        value: _vm.checkFacilitiesAll,
                        callback: function ($$v) {
                          _vm.checkFacilitiesAll = $$v
                        },
                        expression: "checkFacilitiesAll",
                      },
                    },
                    [_vm._v(" 全选 ")]
                  ),
                  _c("div", { staticStyle: { margin: "15px 0" } }),
                  _c(
                    "el-checkbox-group",
                    {
                      on: { change: _vm.handleCheckedFacilitiesChange },
                      model: {
                        value: _vm.listParams.facilities,
                        callback: function ($$v) {
                          _vm.$set(_vm.listParams, "facilities", $$v)
                        },
                        expression: "listParams.facilities",
                      },
                    },
                    _vm._l(_vm.facilitiesList, function (item) {
                      return _c(
                        "el-checkbox",
                        { key: item, attrs: { label: item } },
                        [_vm._v(" " + _vm._s(item) + " ")]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "其他服务：" } },
                [
                  _c(
                    "el-checkbox",
                    {
                      attrs: { indeterminate: _vm.isIndeterminate2 },
                      on: { change: _vm.handleCheckAllServicesChange },
                      model: {
                        value: _vm.checkServicesAll,
                        callback: function ($$v) {
                          _vm.checkServicesAll = $$v
                        },
                        expression: "checkServicesAll",
                      },
                    },
                    [_vm._v(" 全选 ")]
                  ),
                  _c("div", { staticStyle: { margin: "15px 0" } }),
                  _c(
                    "el-checkbox-group",
                    {
                      on: { change: _vm.handleCheckedServicesChange },
                      model: {
                        value: _vm.listParams.services,
                        callback: function ($$v) {
                          _vm.$set(_vm.listParams, "services", $$v)
                        },
                        expression: "listParams.services",
                      },
                    },
                    _vm._l(_vm.servicesList, function (item) {
                      return _c(
                        "el-checkbox",
                        { key: item, attrs: { label: item } },
                        [_vm._v(" " + _vm._s(item) + " ")]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "align-center",
                  staticStyle: {
                    "padding-bottom": "20px",
                    "margin-top": "30px",
                  },
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        disabled: _vm.isDisabled,
                        size: "small",
                        type: "primary",
                      },
                      on: { click: _vm.saveAdd },
                    },
                    [_vm._v(" 保存 ")]
                  ),
                  _c(
                    "el-button",
                    { attrs: { size: "small" }, on: { click: _vm.backToList } },
                    [_vm._v("返回")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }